import StoredLayout from '../../layouts/StoredLayout'
import Reapop from './Reapop'
export default StoredLayout(Reapop)



// WEBPACK FOOTER //
// ./src/notifications/reapop/index.js